import { render, staticRenderFns } from "./lookRatio.vue?vue&type=template&id=74fa8c26&scoped=true"
import script from "./lookRatio.vue?vue&type=script&lang=js"
export * from "./lookRatio.vue?vue&type=script&lang=js"
import style0 from "./lookRatio.vue?vue&type=style&index=0&id=74fa8c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa8c26",
  null
  
)

export default component.exports